import {defaultTheme} from '@stencil/build-theme';

export function getRatingsColor(ratingCount: number, isTA = false): string {
  if (isTA) return defaultTheme.colors.goRatings.taRating;

  if (ratingCount >= 4.5) {
    return defaultTheme.colors.goRatings.ratingDarkGreen;
  }

  if (ratingCount < 4.5 && ratingCount >= 4) {
    return defaultTheme.colors.goRatings.ratingLightGreen;
  }

  if (ratingCount < 4 && ratingCount >= 3.5) {
    return defaultTheme.colors.goRatings.ratingMediumGreen;
  }

  if (ratingCount < 3.5 && ratingCount >= 3) {
    return defaultTheme.colors.goRatings.ratingYellow;
  }

  if (ratingCount < 3 && ratingCount >= 2.5) {
    return defaultTheme.colors.goRatings.ratingOrange;
  }

  if (ratingCount < 2.5 && ratingCount >= 1) {
    return defaultTheme.colors.goRatings.ratingRed;
  }

  return defaultTheme.colors.goTeal.medium;
}

export function getStarRatingColor(ratingCount: number, isTA = false): string {
  if (isTA) return defaultTheme.colors.goRatings.taRating;

  if (ratingCount == 5) {
    return defaultTheme.colors.goRatings.ratingDarkGreen;
  }

  if (ratingCount == 4) {
    return defaultTheme.colors.goRatings.ratingLightGreen;
  }

  if (ratingCount == 3) {
    return defaultTheme.colors.goRatings.ratingYellow;
  }

  if (ratingCount == 2) {
    return defaultTheme.colors.goRatings.ratingOrange;
  }

  if (ratingCount == 1) {
    return defaultTheme.colors.goRatings.ratingRed;
  }

  return defaultTheme.colors.goTeal.medium;
}
